export const CSS_BOX_IMG_LOGIN_GLOBALCREDIT = 'banner_box_img-globalCredit';
export const CSS_BOX_IMG_LOGIN_INSTANTCREDIT_ES = 'banner_box_img_instantCredit_ES';
export const CSS_BOX_IMG_LOGIN_INSTANTCREDIT_CAT = 'banner_box_img_instantCredit_CAT';
export const CSS_BOX_IMG_LOGIN_CLIENT_ES = 'banner_box_img_client_ES';
export const CSS_BANNER_BOX_IMG_CLIENT_CAT = 'banner_box_img_client_CAT';
export const CSS_BANNER_IMG_ES = 'banner_img_ES';
export const CSS_GRID_BOX_ES = 'grid_img_ES';
export const CSS_BANNER_IMG_CAT = 'banner_img_CAT';
export const CSS_GRID_BOX_CAT = 'grid_img_CAT';
export const LINK_LOGIN_GLOBALCREDIT_INFO =
  'https://www.sabadellconsumer.com/cs/Satellite/BSFincom/Contactar/GBS_Form_FA/1191431009984/1191430942557/es/';
export const LINK_LOGIN_INSTANTCREDIT_INFO = 'https://www.instantcredit.net/';
export const LINK_LOGIN_CLIENT_INFO = 'https://www.sabadellconsumeronline.com/WebCliente/';
export const TEXT_LOGIN_BOX_GLOBALCREDIT = 'mat.grid.list.tile.third';
export const TEXT_LOGIN_BOX_INSTANTCREDIT = 'mat.grid.list.tile.fourth';
export const TEXT_LOGIN_BOX_CLIENT = 'mat.grid.list.tile.fifth';
export const TEXT_LOGIN_BOX_CLIENT_STRONG = 'mat.grid.list.tile.fifth.strong';

export const LANGUAGE_SPANISH = 'es-ES';
